import crudTemplate from "../../../templates/crudTemplate.js";
import GroupContact from "../../../utils/services/project/metering/groupContactService";
let crud = crudTemplate(GroupContact);

function prepareItem(i) {
  i.name = i._identity.name;
  (i.id = i._identity.id), (i.contact_id = i.id);
  i.contact_id = i._identity.id;
  i.contact_name = i._identity.name;
  if (i.attributes && i.attributes instanceof Object) {
    i.end = i.attributes.end;
    i.start = i.attributes.start;
  }
  return i;
}
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = {
      id: "",
      group_id: item.group_id,
      project_id: item.project_id,
      _identity: {
        type: "Contact",
        id: item.contact_id
      },
      _roles: item.roles.length ? [{ id: item.roles[0] }] : [],
      attributes: {
        end_date: item.end,
        start_date: item.start
      }
    };
    return crud.actions.update(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  },
  delete(store, { id, params = {}, onSuccess = () => {}, onError = () => {} }) {
    store.dispatch("update", {
      item: { ...params, contact_id: id, roles: [] },
      onError,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
